import {
    AttachMoney,
    Group,
    Insights,
    Kitchen,
    LocalOffer,
    ReceiptLong,
    Restaurant,
    RoomService,
    Settings,
    ShoppingCart,
    SportsMotorsports,
    Storefront,
} from "@mui/icons-material";
import { IGrupoNavegacao } from "../interfaces/INavegacao";

const MODULOS_MARKETPLACE = ["Marketplaces - Cozinheiro", "Marketplaces - Aprendiz"];
const MODULOS_ESTOQUE = ["Controle de estoque simples", "Controle de estoque completo"];

/**
 * Fonte única de verdade da navegação do sistema.
 *
 * Cada grupo vira uma seção do menu lateral e cada módulo vira um acordeão com
 * seus itens. A visibilidade é resolvida em `useNavegacao` a partir dos módulos
 * do perfil do usuário.
 */
export const NAVEGACAO: IGrupoNavegacao[] = [
    {
        id: "principal",
        titulo: "Principal",
        modulos: [
            {
                id: "dashboard",
                titulo: "Dashboard",
                icone: Insights,
                url: "/dashboard",
            },
        ],
    },
    {
        id: "operacao",
        titulo: "Operação",
        modulos: [
            {
                id: "pedidos",
                titulo: "Pedidos",
                icone: ReceiptLong,
                url: "/pedidos/operacao",
                prefixos: ["/pedidos"],
                itens: [
                    { titulo: "PDV", url: "/pedidos/operacao" },
                    {
                        titulo: "Conversas",
                        url: "/pedidos/conversas",
                        modulos: ["Atendimento"],
                        notificacao: "conversas",
                    },
                    { titulo: "Operação", url: "/pedidos/listagem" },
                    { titulo: "Avaliações", url: "/pedidos/avaliacoes" },
                ],
            },
            {
                id: "cardapio",
                titulo: "Cardápio",
                icone: Restaurant,
                url: "/cardapio",
                prefixos: ["/cardapio"],
                modulos: ["Cardápio"],
                itens: [
                    { titulo: "Cardápio", url: "/cardapio" },
                    {
                        titulo: "Controle de estoque",
                        url: "/cardapio/estoque",
                        modulos: MODULOS_ESTOQUE,
                        subitens: [
                            {
                                titulo: "Itens e produtos",
                                url: "/cardapio/estoque/itens",
                                modulos: MODULOS_ESTOQUE,
                            },
                            {
                                titulo: "Insumos e ingredientes",
                                url: "/cardapio/estoque/insumos",
                                modulos: ["Controle de estoque completo"],
                            },
                        ],
                    },
                ],
            },
            {
                id: "cozinha",
                titulo: "Cozinha",
                icone: Kitchen,
                url: "/cozinha/configuracao",
                prefixos: ["/cozinha"],
                modulos: ["Configurações"],
                itens: [
                    { titulo: "KDS", url: "/cozinha/configuracao" },
                    { titulo: "Fluxo de trabalho", url: "/cozinha/fluxo/operacao" },
                ],
            },
        ],
    },
    {
        id: "gestao",
        titulo: "Gestão",
        modulos: [
            {
                id: "financeiro",
                titulo: "Financeiro",
                icone: AttachMoney,
                url: "/financeiro/caixa",
                prefixos: ["/financeiro"],
                modulos: ["Financeiro"],
                itens: [
                    { titulo: "Caixa", url: "/financeiro/caixa" },
                    { titulo: "Contas", url: "/financeiro/contas" },
                    {
                        titulo: "Relatórios",
                        url: "/financeiro/relatorios",
                        subitens: [
                            { titulo: "Caixa diário", url: "/financeiro/relatorios/caixa-diario" },
                            { titulo: "Contas mensais", url: "/financeiro/relatorios/contas-mensais" },
                            { titulo: "Itens mais vendidos", url: "/financeiro/relatorios/itens-vendidos" },
                            { titulo: "Combos mais vendidos", url: "/financeiro/relatorios/combos-vendidos" },
                            { titulo: "Conciliação de pagamentos", url: "/financeiro/relatorios/conciliacao-pagamentos" },
                        ],
                    },
                    {
                        titulo: "Contabilidade",
                        url: "/financeiro/contabilidade",
                        subitens: [
                            { titulo: "Notas fiscais", url: "/financeiro/contabilidade/nfce" },
                        ],
                    },
                ],
            },
            {
                id: "clientes",
                titulo: "Clientes",
                icone: RoomService,
                url: "/clientes/listar",
                prefixos: ["/clientes"],
                modulos: ["Gestão de clientes"],
                itens: [
                    { titulo: "Base de clientes", url: "/clientes/listar" },
                    { titulo: "Fidelidade", url: "/clientes/programas-fidelidade" },
                ],
            },
            {
                id: "promocoes",
                titulo: "Promoções",
                icone: LocalOffer,
                url: "/promocoes/campanhas",
                prefixos: ["/promocoes"],
                modulos: ["Cardápio"],
                itens: [
                    { titulo: "Campanhas", url: "/promocoes/campanhas" },
                    { titulo: "Cupons", url: "/promocoes/cupons" },
                    { titulo: "Programas de fidelidade", url: "/promocoes/programas-fidelidade" },
                ],
            },
            {
                id: "entregadores",
                titulo: "Entregadores",
                icone: SportsMotorsports,
                url: "/entregadores",
                prefixos: ["/entregadores"],
                modulos: ["Entregadores"],
                itens: [
                    { titulo: "Base de entregadores", url: "/entregadores" },
                    { titulo: "Cadastrar", url: "/entregadores/cadastrar" },
                ],
            },
            {
                id: "marketplaces",
                titulo: "Marketplaces",
                icone: ShoppingCart,
                url: "/marketplace",
                prefixos: ["/marketplace"],
                modulos: MODULOS_MARKETPLACE,
                itens: [
                    { titulo: "Meus marketplaces", url: "/marketplace" },
                    { titulo: "Cadastrar", url: "/marketplace/cadastrar" },
                ],
            },
        ],
    },
    {
        id: "administracao",
        titulo: "Administração",
        modulos: [
            {
                id: "usuarios",
                titulo: "Usuários",
                icone: Group,
                url: "/usuarios/meu-perfil",
                prefixos: ["/usuarios"],
                itens: [
                    { titulo: "Meu perfil", url: "/usuarios/meu-perfil" },
                    { titulo: "Base de usuários", url: "/usuarios", modulos: ["Gestão de usuários"] },
                    { titulo: "Cadastrar", url: "/usuarios/cadastrar", modulos: ["Gestão de usuários"] },
                ],
            },
            {
                id: "configuracoes",
                titulo: "Configurações",
                icone: Settings,
                url: "/configuracoes/metodos-pagamento",
                prefixos: ["/configuracoes"],
                modulos: ["Configurações"],
                itens: [
                    { titulo: "Métodos de pagamento", url: "/configuracoes/metodos-pagamento" },
                    { titulo: "Maquininhas", url: "/configuracoes/maquininhas" },
                    { titulo: "Bandeiras de cartão", url: "/configuracoes/bandeiras" },
                    { titulo: "Número de mesas", url: "/configuracoes/numero-mesas" },
                    { titulo: "Entrega", url: "/configuracoes/entrega" },
                    { titulo: "Tempo de entrega", url: "/configuracoes/tempo-entrega" },
                    { titulo: "Taxa de serviço", url: "/configuracoes/taxa-servico" },
                    { titulo: "Contabilidade", url: "/configuracoes/contabilidade" },
                    { titulo: "Tema", url: "/configuracoes/tema" },
                ],
            },
            {
                id: "estabelecimentos",
                titulo: "Estabelecimentos",
                icone: Storefront,
                url: "/estabelecimentos",
                prefixos: ["/estabelecimentos"],
            },
        ],
    },
];
